import {
    ApolloClient,
    InMemoryCache,
    ApolloLink,
    fromPromise,
    createHttpLink, useMutation,
} from '@apollo/client';
import { SEND_ERROR, UPDATE_TOKEN } from './queries';
import { updateAccessTokenWithRefreshToken } from "./types/updateAccessTokenWithRefreshToken";
import { setContext } from "@apollo/client/link/context";
import { onError } from "@apollo/client/link/error";
import {useNavigate} from "react-router-dom";

const httpLink = createHttpLink({
  uri: process.env.REACT_APP_GRAPHQL_URL,
});

const guestClient = new ApolloClient({
  link: httpLink,
  cache: new InMemoryCache(),
});

const updateToken = () => {
  const refreshToken = localStorage.getItem("refreshToken");
  return guestClient
    .mutate<updateAccessTokenWithRefreshToken>({
      variables: { refreshTokenInput: { refreshToken } },
      mutation: UPDATE_TOKEN,
    })
    .then((res) => {
      const token = res?.data?.updateAccessTokenWithRefreshToken?.accessToken;
      const refreshToken =
        res?.data?.updateAccessTokenWithRefreshToken?.refreshToken;
      localStorage.setItem("token", token || "");
      localStorage.setItem("refreshToken", refreshToken || "");
      return token;
    }).catch((reason) => {
        throw reason
    });
};

const errorLink = onError(({ graphQLErrors, operation, forward }) => {
  if (graphQLErrors) {
    for (let err of graphQLErrors) {
      switch (err.extensions.code) {
          // Apollo Server sets code to UNAUTHENTICATED
          // when an AuthenticationError is thrown in a resolver
        case "UNAUTHENTICATED":
          // Modify the operation context with a new token
          return fromPromise(
              updateToken().catch((error) => {
                console.error(error)
                localStorage.removeItem("me");
                localStorage.removeItem("token");
                localStorage.removeItem("userRole");

                window.location.href = '/'
              })
          )
              .filter((value) => Boolean(value))
              .flatMap((accessToken) => {
                const oldHeaders = operation.getContext().headers;
                operation.setContext({
                  headers: {
                    ...oldHeaders,
                    authorization: accessToken,
                  },
                });

                return forward(operation);
              })
        // default:
        //     sendError({
        //         variables: {
        //             input: {
        //                 message: err.message,
        //                 stacktrace: err.locations?.join(';')
        //             }
        //         }
        //     })
        //     throw err
      }
    }
  }
});

const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem("token");
  return {
    headers: {
      ...headers,
      Authorization: token,
    },
  };
});

export const client = new ApolloClient({
  link: ApolloLink.from([authLink, errorLink, httpLink]),
  cache: new InMemoryCache({
    addTypename: false,
  }),
});
